import { render } from "./CommonPopup.vue?vue&type=template&id=5dfc30f0&scoped=true"
import script from "./CommonPopup.vue?vue&type=script&lang=js"
export * from "./CommonPopup.vue?vue&type=script&lang=js"

import "./CommonPopup.vue?vue&type=style&index=0&id=5dfc30f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfc30f0"]])

export default __exports__